import { render, staticRenderFns } from "./gmapSatgas.vue?vue&type=template&id=1bb3b71b"
import script from "./gmapSatgas.vue?vue&type=script&lang=js"
export * from "./gmapSatgas.vue?vue&type=script&lang=js"
import style0 from "./gmapSatgas.vue?vue&type=style&index=0&id=1bb3b71b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports